module.exports = __webpack_public_path__ + "img/logo_orangelife@3x.b60b3986.png";